const style = theme => ({
  bodyRow: {
    //backgroundColor: 'transparent',
    // '&:nth-child(odd)': {
    //   backgroundColor: '#f9fafc',
    // },
    padding: 15,
    [theme.breakpoints.down('sm')]: {
      padding: 12,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 8,
    },
  },
  childList: {
    paddingLeft: theme.spacing(6),
    paddingBottom: theme.spacing(2),
    paddingRight: '0!important',
    paddingTop: 0,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
  },
  dragHandle: {},
  tableBody: {
    backgroundColor: '#FFF',
  },
  td: {
    [theme.breakpoints.down('sm')]: {
      padding: '8px 4px',
      '& .MuiTypography-root': {
        fontSize: '13px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      },
    },
    [theme.breakpoints.down('xs')]: {
      padding: '6px 2px',
      '& .MuiTypography-root': {
        fontSize: '12px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      },
    },
  },
})

export default style
